import { CpClaimRequestInterface } from '../../../interfaces/request/claim/cp-claim-request-interface';

export class CpClaimRequestModel implements CpClaimRequestInterface {
  Cards: string = '';
  ClaimStatus: string = '';
  EndDate: string = '';
  Page: number = 1;
  PageSize: number = 5;
  StartDate: string = '';

  constructor(init?: Partial<CpClaimRequestModel>) {
    Object.assign(this, init);
  }
}
